import { useEffect, useCallback } from 'react';

const CHECKPOINTS_PROGRESSES = [0, 0.17, 0.31, 0.45, 0.66, 0.8, 1];
const CHECKPOINT_TRANSITION =
  'fill 0.35s cubic-bezier(0.33, 1, 0.68, 1), stroke 0.35s cubic-bezier(0.33, 1, 0.68, 1)';

const activateCheckpoint = id => {
  const checkpoint = document.getElementById(id);
  if (!checkpoint) return;

  const paths = checkpoint.querySelectorAll('path');
  paths[0].style.fill = '#00BE85';
  if (paths.length >= 3) {
    paths[1].style.stroke = '#00BE85';
    paths[2].style.fill = '#151D28';
  }
};

const deactivateCheckpoint = id => {
  const checkpoint = document.getElementById(id);
  if (!checkpoint) return;

  const paths = checkpoint.querySelectorAll('path');
  paths[0].style.fill = '#151D28';
  if (paths.length >= 3) {
    paths[1].style.stroke = '#293848';
    paths[2].style.fill = '#FFFAEA';
  }
};

const useMobileStagesAnimation = greenLineRef => {
  useEffect(() => {
    if (!greenLineRef?.current) return;
    const greenLine = greenLineRef.current;
    const length = greenLine.getTotalLength();

    greenLine.style.strokeDasharray = String(length);
    greenLine.style.strokeDashoffset = String(length);
    greenLine.style.transition = 'stroke-dashoffset 0.35s cubic-bezier(0.33, 1, 0.68, 1)';

    for (let i = 2; i <= CHECKPOINTS_PROGRESSES.length; i++) {
      const checkpoint = document.getElementById(`mobile-checkpoint-${i}`);
      if (!checkpoint) continue;

      checkpoint
        .querySelectorAll('path')
        .forEach(path => (path.style.transition = CHECKPOINT_TRANSITION));
    }
  }, []);

  const handleSlideChange = useCallback(swiperInstance => {
    const index = swiperInstance.activeIndex;
    if (!greenLineRef?.current) return;

    const greenLine = greenLineRef.current;
    const progress =
      CHECKPOINTS_PROGRESSES[index] ?? CHECKPOINTS_PROGRESSES[CHECKPOINTS_PROGRESSES.length - 1];

    greenLine.style.strokeDashoffset = String(greenLine.getTotalLength() * (1 - progress));

    for (let i = 1; i <= CHECKPOINTS_PROGRESSES.length - 1; i++) {
      if (i <= index) activateCheckpoint(`mobile-checkpoint-${i + 1}`);
      else deactivateCheckpoint(`mobile-checkpoint-${i + 1}`);
    }
  }, []);

  return { handleSlideChange };
};

export default useMobileStagesAnimation;
